<template>
  <template class="flex w-full">
    <span
      v-if="!editing"
      class="flex-grow"
    >{{ form[attribute] }}</span>

    <template v-if="editing">
      <form
        class="w-full"
        @submit.prevent="save"
      >
        <TabGroup v-slot="{ selectedIndex }">
          <TabList class="flex items-center">
            <Tab
              v-slot="{ selected }"
              as="template"
            >
              <button :class="[selected ? 'text-gray-900 bg-gray-100 hover:bg-gray-200' : 'text-gray-500 hover:text-gray-900 bg-white hover:bg-gray-100', 'px-3 py-1.5 border border-transparent text-sm font-medium rounded-md']">
                Write
              </button>
            </Tab>
            <Tab
              v-slot="{ selected }"
              as="template"
            >
              <button :class="[selected ? 'text-gray-900 bg-gray-100 hover:bg-gray-200' : 'text-gray-500 hover:text-gray-900 bg-white hover:bg-gray-100', 'ml-2 px-3 py-1.5 border border-transparent text-sm font-medium rounded-md']">
                Preview
              </button>
            </Tab>

            <!-- These buttons are here simply as examples and don't actually do anything. -->
            <div
              v-if="selectedIndex === 0"
              class="ml-auto flex items-center space-x-5"
            >
              <div class="flex items-center">
                <button
                  type="button"
                  class="-m-2.5 w-10 h-10 rounded-full inline-flex items-center justify-center text-gray-400 hover:text-gray-500"
                >
                  <span class="sr-only">Insert link</span>
                  <LinkIcon
                    class="h-5 w-5"
                    aria-hidden="true"
                  />
                </button>
              </div>
            </div>
          </TabList>
          <TabPanels class="mt-2">
            <TabPanel class="p-0.5 -m-0.5 rounded-lg">
              <div>
                <textarea
                  :id="attribute"
                  id="comment"
                  v-model="form[attribute]"
                  rows="5"
                  name="comment"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                />
              </div>
            </TabPanel>
            <TabPanel class="p-0.5 -m-0.5 rounded-lg">
              <div class="border-b">
                <div class="mx-px mt-px px-3 pt-2 pb-12 text-sm leading-5 text-gray-800">
                  {{ form[attribute] }}
                </div>
              </div>
            </TabPanel>
          </TabPanels>
        </TabGroup>
        <jet-input-error
          :message="form.errors[attribute]"
          class="mt-2"
        />
        <div class="mt-2 flex justify-end">
          <button
            :class="{ 'opacity-25': form.processing }"
            :disabled="form.processing"
            type="button"
            class="font-medium text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 p-1"
            @click="cancel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </button>
          <jet-button
            :class="{ 'opacity-25': form.processing }"
            :disabled="form.processing"
          >
            Save
          </jet-button>
        </div>
      </form>
    </template>

    <span class="ml-4 flex-shrink-0">
      <template v-if="!editing">
        <span
          v-if="recentlySuccessful"
          class="text-green-600"
        >Saved</span>
        <button
          v-else
          type="button"
          class="bg-white rounded-md font-medium text-purple-600 hover:text-purple-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
          @click="open"
        >
          Update
        </button>
      </template>
    </span>
  </template>
</template>

<script>

import {
  Tab, TabGroup, TabList, TabPanel, TabPanels,
} from '@headlessui/vue';
import { AtSymbolIcon, CodeBracketIcon, LinkIcon } from '@heroicons/vue/24/solid';
import JetInputError from '@/Jetstream/InputError';
import JetLabel from '@/Jetstream/Label';
import JetButton from '@/Jetstream/Button';

export default {

  components: {
    JetButton,
    JetInputError,
    JetLabel,
    Tab,
    TabGroup,
    TabList,
    TabPanel,
    TabPanels,
    AtSymbolIcon,
    CodeBracketIcon,
    LinkIcon,
  },
  props: [
    'form',
    'attribute',
  ],

  emits: ['submitted'],
  data() {
    return {
      editing: false,
      initial_value: null,
      saved: false,
    };
  },
  computed: {
    recentlySuccessful() {
      return this.saved && this.form.recentlySuccessful;
    },
  },
  watch: {
    recentlySuccessful(val, oldVal) {
      if (val === true) {
        this.editing = false;
      }
    },
  },
  methods: {
    cancel() {
      this.form[this.attribute] = this.initial_value;
      this.initial_value = null;
      this.saved = false;
      this.editing = false;
    },
    open() {
      this.saved = false;
      this.initial_value = this.form[this.attribute];
      this.editing = true;
    },
    save() {
      this.saved = true;
      this.$emit('submitted');
      setTimeout(() => this.saved = false, 10000);
    },
  },
};
</script>
